export const styles = {
    bold: {
        fontWeight: 600
    }
};
